module.exports = __webpack_public_path__ + "assets/img/img-hotel-13.70d82e36.jpg";